import { styled } from '../../../Utilities';
import { PersonaCoinBase } from './PersonaCoin.base';
import { getStyles } from './PersonaCoin.styles';
/**
 * PersonaCoin is used to render an individual's avatar and presence.
 */
export var PersonaCoin = styled(PersonaCoinBase, getStyles, undefined, {
    scope: 'PersonaCoin'
});
//# sourceMappingURL=PersonaCoin.js.map